import { useRef, useEffect } from "react";
import SEO from "../components/SEO";

declare const navigator: {
    gpu: any;
}

export default function WebGPUIntro() {

    const canvasRef = useRef<HTMLCanvasElement>(null);

    // Resize canvas to full window size
    useEffect(() => {
        const canvas = canvasRef.current;
        if (!canvas) return;

        const resizeCanvas = () => { canvas.width = window.innerWidth; canvas.height = window.innerHeight; };
        resizeCanvas();
        window.addEventListener('resize', resizeCanvas);
        return () => { window.removeEventListener('resize', resizeCanvas); };
    }, []);


    useEffect(() => {
        if (!navigator.gpu) {
            throw new Error("WebGPU not supported on this browser.");
        }

        let adapter: any;
        let device: any;

        navigator.gpu.requestAdapter().then((adap: any) => {
            console.log(adap);
            adapter = adap;
            if (!adapter) {
                throw new Error("No appropriate GPUAdapter found.");
            }
            adapter.requestDevice().then((dev: any) => {
                device = dev;

                const context = canvasRef.current?.getContext('webgpu') as any;
                const format = navigator.gpu.getPreferredCanvasFormat();
                if (context) {
                    context.configure({
                        device: device,
                        format: format,
                        alphaMode: 'opaque'
                    });

                }

                const encoder = device.createCommandEncoder();

                const pass = encoder.beginRenderPass({
                    colorAttachments: [{
                        view: context.getCurrentTexture().createView(),
                        loadOp: "clear",
                        clearValue: { r: 1, g: 1, b: 0.55, a: 1 }, // New line
                        storeOp: "store",
                    }]
                });

                pass.end();
                const commandBuffer = encoder.finish();
                device.queue.submit([commandBuffer]);
                // Finish the command buffer and immediately submit it.
                device.queue.submit([encoder.finish()]);

            });
        });
    }, []);

    return (
        <>
            <SEO
                title="WebGPU Game of Life"
                description="A WebGPU implementation of Conway's Game of Life."
                url="https://estebanlasso.com/personal_projects/webgpu_gameoflife"
            />
            <canvas
                ref={canvasRef}
                style={{
                    top: 0,
                    left: 0,
                    width: '100vw',
                    height: '100vh',
                    display: 'block',
                    zIndex: -1
                }}
            ></canvas>
        </>
    );
}